import React from "react";
import { ReactComponent as FilterIcon } from "../../../../../../assets/utils/images/svgs/filter.svg";

export default function FilterHeaderCell({ handleClick, allRows, visibleRows }) {
	const openRows = allRows
		.flatMap((row) => Object.values(row?.data || {}))
		.filter((item) => item?.status === "Openstaand");

	const totalOpenCount = openRows.length;
	const isAllVisible = totalOpenCount === visibleRows.length;
	const rowLabel = isAllVisible ? totalOpenCount : `${visibleRows.length}/${totalOpenCount}`;
	return (
		<div className="text-start d-flex align-items-center gap-2">
			<FilterIcon onClick={() => handleClick()} /> Dag ({rowLabel})
		</div>
	);
}
